import "./App.css";
import KnowYourEligibilityForm from "./components/KnowYourEligibilityForm";

function App() {
  return (
    <KnowYourEligibilityForm />
  );
}

export default App;
